import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ProjectService } from "@services";
import utils from "@utils";
import { ProjectForm, ProjectLocations } from "./components";

import "./ProjectDetails.scss";

const ProjectDetails = ({ user, router, params }) => {
	const { lang } = global;

	const [activeTab, setActiveTab] = useState("form");

	const [project, setProject] = useState(undefined);

	const changeTab = ({ target: { name } }) => {
		setActiveTab(name);
	};

	/**
	 * Retrieves the details for a specific project
	 * @param {Number} projectId The uniqe id of the project being viewed
	 */
	const getProject = projectId => {
		ProjectService.getProject(projectId)
			.then(({ data }) => {
				setProject({
					...data,
					SecondaryProjectSupervisorModel:
						data.SecondaryProjectSupervisorModel.length === 0
							? [{}]
							: data.SecondaryProjectSupervisorModel,
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading project"),
					title: "Error",
				});
			});
	};

	useEffect(() => {
		if (router.params.projectId) {
			getProject(router.params.projectId);
		}
		return () => {
			setProject(undefined);
		};
	}, []);

	return (
		<div
			id="project-details"
			className="container"
		>
			<div className="row">
				<div className="col-sm-10 col-sm-offset-1">
					<h2>{params.projectId ? lang.t("Edit Project") : lang.t("Add Project")}</h2>
				</div>
			</div>
			<If condition={params.projectId}>
				<ul
					className="row nav tabs"
					role="presentation"
				>
					<li
						role="presentation"
						className={`col-xs-5 col-xs-offset-1 col-sm-3 col-sm-offset-3 col-md-2 col-md-offset-4${
							activeTab === "form" ? " active" : ""
						}`}
					>
						<button
							type="button"
							role="tab"
							name="form"
							className="btn-block"
							onClick={changeTab}
						>
							{lang.t("Project Details")}
						</button>
					</li>
					<li
						role="presentation"
						className={`col-xs-5 col-sm-3 col-md-2${activeTab === "locations" ? " active" : ""}`}
					>
						<button
							type="button"
							role="tab"
							name="locations"
							className="btn-block"
							onClick={changeTab}
						>
							{lang.t("Locations")}
						</button>
					</li>
				</ul>
			</If>
			<div className="row">
				<Choose>
					<When condition={params.projectId}>
						<div
							className={
								activeTab === "form"
									? "col-sm-8 col-sm-offset-2"
									: "col-sm-10 col-sm-offset-1"
							}
						>
							<div className="tab-content">
								<div className={`tab-pane ${activeTab === "form" ? "active" : ""}`}>
									<ProjectForm
										user={user}
										router={router}
										project={project}
									/>
								</div>
								<div
									className={`tab-pane ${activeTab === "locations" ? "active" : ""}`}
								>
									<ProjectLocations
										projectId={router.params.projectId}
										project={project}
										user={user}
									/>
								</div>
							</div>
						</div>
					</When>
					<Otherwise>
						<div className="col-sm-8 col-sm-offset-2">
							<ProjectForm
								user={user}
								router={router}
							/>
						</div>
					</Otherwise>
				</Choose>
			</div>
		</div>
	);
};

ProjectDetails.propTypes = {
	user: PropTypes.object,
	router: PropTypes.object.isRequired,
	params: PropTypes.object.isRequired,
};

ProjectDetails.defaultProps = {
	user: {},
};

export default ProjectDetails;
